const houseOfDragonS03E01 = {
  videoId: 'house_of_dragon_s03e01',
  episodeTag: 'S03E01',
  railLabel: 'S03·A01',
  quickQuestions: [
    '这个角色是谁',
    '解释这个镜头',
    '这是什么梗',
    '这句台词什么意思',
  ],
};

export default houseOfDragonS03E01;
